import React from 'react';
import TemplateEditor from 'PDF/TemplateEditor/TemplateEditor';

function PdfTemplateEditorPage() {
  return <TemplateEditor />;
}

export default PdfTemplateEditorPage;
